import { IoCamera, IoTrash } from "react-icons/io5";

const ImageUploadContainer = ({ imageUrl, onUpload, onDelete, isLoading }) => {
    return (
        <div className="w-full h-48 bg-gray-100 relative overflow-hidden">
            {imageUrl ? (
                <>
                    <img
                        src={imageUrl}
                        className="w-full h-full object-cover"
                    />
                    <div className="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center">
                        <div className="flex space-x-4">
                            <label className="px-4 py-2 bg-white bg-opacity-90 text-gray-800 rounded-lg cursor-pointer active:bg-opacity-100 transition-all">
                                <IoCamera size={20} className="inline mr-2" />
                                변경
                                <input
                                    type="file"
                                    accept="image/*"
                                    onChange={onUpload}
                                    className="hidden"
                                    disabled={isLoading}
                                />
                            </label>
                            <button
                                onClick={onDelete}
                                className="px-4 py-2 bg-red-500 bg-opacity-90 text-white rounded-lg active:bg-opacity-100 transition-all"
                                disabled={isLoading}
                            >
                                <IoTrash size={20} className="inline mr-2" />
                                삭제
                            </button>
                        </div>
                    </div>
                </>
            ) : (
                <label className="w-full h-full flex items-center justify-center cursor-pointer active:bg-gray-200 transition-colors">
                    <div className="text-center">
                        <IoCamera size={32} className="text-gray-400 mx-auto mb-2" />
                        <p className="text-gray-400">사진 추가</p>
                    </div>
                    <input
                        type="file"
                        accept="image/*"
                        onChange={onUpload}
                        className="hidden"
                        disabled={isLoading}
                    />
                </label>
            )}
        </div>
    );
};

export default ImageUploadContainer;
